// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import {
  getOrganisation,
  getOrganisations
} from '../organisations/basicCreators';
import type { ThunkAction } from '../../types';

type Action = {
  +type: string
};

export function updateCurrentCustomer(
  organisationId: number,
  withSettings: boolean = true
): ThunkAction {
  return function(dispatch) {
    if (organisationId) {
      // Get the organisation
      return (
        dispatch(getOrganisation(organisationId, withSettings))
          // set as current Organisation
          .then(
            orgWithSettings => {
              dispatch({
                type: 'UPDATE_CURRENT_CUSTOMER',
                customer: orgWithSettings,
                settings: orgWithSettings.settings
              });
              dispatch(getOrganisations(orgWithSettings.id));
              return orgWithSettings;
            },
            () => Promise.reject()
          )
      );
    } else {
      return dispatch(clearCurrentCustomer());
    }
  };
}

export function getCustomerSettings(
  organisationId: ?number = undefined
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisation/settings';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {}
    };

    options.params.productId = config.productId;

    if (organisationId) {
      options.params.organisationId = organisationId;
    }

    return makeAPICall(endpoint, options).then(
      response =>
        dispatch({
          type: 'UPDATE_CURRENT_CUSTOMER_SETTINGS',
          settings: response.data
        }),
      error => dispatch(APIError(error, 'Error getting organisation settings'))
    );
  };
}

export function clearCurrentCustomer(): Action {
  return { type: 'CLEAR_CURRENT_CUSTOMER' };
}



// WEBPACK FOOTER //
// ./src/actions/customers/currentCustomerCreators.js